import styled from 'styled-components';

import { SteeringWheelCheckbox as SteeringWheelCheckboxBase } from 'components/modules/Insurance/components/SteeringWheelCheckbox/SteeringWheelCheckbox';
import { FormWrapper as FormWrapperBase } from 'components/modules/Insurance/components/FormWrapper/FormWrapper';
import { VinOrBodyNumberInput as VinOrBodyNumberInputBase } from 'components/modules/Insurance/components/VinOrBodyNumberInput/VinOrBodyNumberInput';

import { TypeOfUse as TypeOfUseBase } from '../TypeOfUse/TypeOfUse';

export const SteeringWheelCheckbox = styled(SteeringWheelCheckboxBase)`
  grid-column: 1 / 3;
`;

export const FormWrapper = styled(FormWrapperBase)`
  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const VinOrBodyNumberInput = styled(VinOrBodyNumberInputBase)`
  grid-column: 1 / 3;
`;

export const TypeOfUse = styled(TypeOfUseBase)`
  grid-column: 1 / 3;
`;
